import React from "react";

function MainImg() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 441 437"
        >
            <path
                fill="#BDD0FB"
                d="M393.298 258.083c-18.631.801-39.359-20.392-44.131-41.088-4.909-21.294 10.365-27.832 14.122-55.925 4.264-31.914-13.337-39.236-19.506-83.895C342.39 67.1 334.342 8.79 355.342.96c19.415-7.242 66.353 27.672 70.334 64.63 2.839 26.352-18.252 34.352-14.842 65.066 2.989 26.945 20.216 29.699 23.381 55.737 3.848 31.696-16.459 70.639-40.917 71.69z"
            ></path>
            <path
                fill="#91B3FA"
                d="M390.912 265.629c9.628-33.691 7.37-88.031 3.779-127.678-3.891-42.93-10.13-78.366-10.194-78.718l-1.569.197c.064.353 6.298 35.741 10.178 78.617 3.581 39.535 5.838 93.693-3.731 127.187l1.537.401v-.006z"
            ></path>
            <path
                fill="#BDD0FB"
                d="M74.652 259.236c27.869-6.399 47.695-48.122 37.459-66.027-6.916-12.093-23.071-5.471-33.51-18.861-13.331-17.093 5.171-37.939.192-72.516-4.237-29.428-24.426-61.48-41.381-60.392C19.662 42.577.64 80.34 8.337 108.044c5.005 18.017 18.7 22.404 17.926 37.747-.897 17.804-19.805 21.113-24.155 37.47-7.823 29.379 35.677 84.439 72.544 75.97v.005z"
            ></path>
            <path
                fill="#7D97F4"
                d="M58.48 267.033c.145.037.305.042.465.01.56-.112.923-.656.811-1.216-15.092-75.506-4.392-155.761-4.285-156.567a1.03 1.03 0 10-2.044-.283c-.112.806-10.855 81.408 4.306 157.25.08.4.385.699.753.795l-.005.011z"
            ></path>
            <path
                fill="url(#paint0_linear_0_407)"
                d="M24.747 122.779a.483.483 0 00.32-.027c.251-.107.368-.4.256-.651-6.841-15.856-13.07-38.617-3.9-57.04 5.459-10.973 13.902-15.237 13.987-15.28a.492.492 0 00.224-.661.492.492 0 00-.662-.224c-.357.176-8.827 4.456-14.436 15.727-5.155 10.354-8.662 28.803 3.875 57.873a.501.501 0 00.33.283h.006z"
            ></path>
            <path
                fill="#7D97F4"
                d="M381.487 128.484a5.12 5.12 0 00-5.289-5.033l-110.957 3.544a5.123 5.123 0 00-4.958 5.273l5.475 183.768a5.126 5.126 0 005.172 4.974l108.727-1.057a5.126 5.126 0 003.623-1.548 5.136 5.136 0 001.452-3.661l-3.245-186.255v-.005z"
            ></path>
            <g fill="#BDD0FB" opacity="0.63">
                <path d="M369.912 137.167H271.1c-.96 0-1.734.667-1.723 1.574l.096 8.705c.01.912.8 1.942 1.766 1.942l99.094.102c.982 0 1.74-1.057 1.708-1.98l-.299-8.747c-.032-.918-.848-1.596-1.825-1.596h-.005zM370.552 156.065l-99.238-.166c-.966 0-1.74.918-1.729 1.842l.096 8.816c.011.923.806 1.799 1.772 1.799l99.526.272c.988 0 1.756-.876 1.724-1.809l-.304-8.897c-.032-.929-.859-1.857-1.841-1.862l-.006.005zM371.225 175.939l-99.692-.341c-.971 0-1.751.442-1.74 1.371l.096 8.891c.011.929.806 1.633 1.777 1.639l99.959.443c.987 0 1.766-.7 1.734-1.639l-.304-8.976c-.032-.934-.848-1.393-1.836-1.399l.006.011zM371.876 195.322l-100.13-.512c-.971 0-1.756.624-1.745 1.563l.096 8.972c.011.939.806 1.467 1.783 1.473l100.401.619c.993.005 1.783-.518 1.751-1.468l-.31-9.057c-.032-.944-.859-1.59-1.846-1.595v.005zM372.532 214.871l-100.567-.683a1.753 1.753 0 00-1.751 1.756l.097 9.051c.01.95.816 1.975 1.798 1.98l100.861.801c.998.01 1.771-1.014 1.739-1.975l-.309-9.136c-.032-.95-.87-1.788-1.863-1.794h-.005zM373.199 234.596l-101.015-.859c-.982-.01-1.767.998-1.756 1.954l.096 9.131c.011.955.816 1.809 1.804 1.82l101.309.976a1.745 1.745 0 001.755-1.798l-.314-9.217c-.032-.96-.881-1.99-1.879-2.001v-.006zM373.893 255.186l-101.48-1.046c-.987-.011-1.782.507-1.772 1.467l.102 9.212c.01.966.821 1.638 1.809 1.649l101.762 1.163c1.009.011 1.804-.651 1.767-1.622l-.315-9.302c-.032-.971-.865-1.511-1.868-1.521h-.005zM374.571 275.268l-101.933-1.232c-.993-.011-1.788.699-1.778 1.665l.102 9.291c.011.971.822 1.468 1.814 1.478l102.217 1.345c1.014.011 1.814-.464 1.782-1.446l-.32-9.382c-.032-.977-.875-1.713-1.884-1.724v.005zM375.253 295.532l-102.392-1.419c-.998-.016-1.793.891-1.782 1.867l.101 9.377c.011.982.833 1.991 1.831 2.007l102.691 1.542c1.019.016 1.809-.976 1.772-1.969l-.321-9.468c-.032-.987-.886-1.921-1.9-1.937z"></path>
            </g>
            <path
                fill="#7D97F4"
                d="M211.312 26.646c-.064-3.293-2.727-5.998-5.999-5.998H81.75c-3.314 0-6.564 2.85-6.564 6.185v298.158c0 1.606.917 3.143 2.044 4.274 1.126 1.132 2.801 1.767 4.392 1.762l129.194-.358a6.04 6.04 0 004.306-1.814 6.153 6.153 0 001.73-4.377l-5.54-297.837v.005z"
            ></path>
            <g fill="#BDD0FB" opacity="0.81">
                <path d="M120.314 55.78l-35.201-.047-.278-18.167h35.234l.245 18.215zM159.769 55.775l-35.165-.048-.24-18.161h35.197l.208 18.21zM199.187 55.764l-35.133-.047-.202-18.151h35.164l.171 18.198zM120.752 88.394l-35.138.021-.278-18.049 35.175-.016.241 18.044zM160.143 88.368l-35.106.02-.24-18.038 35.138-.016.208 18.034zM199.485 88.34l-35.068.022-.197-18.028 35.1-.016.165 18.023zM121.189 120.778l-35.074.037-.277-17.985 35.111-.032.24 17.98zM160.511 120.734l-35.041.038-.241-17.975 35.074-.032.208 17.969zM199.79 120.697l-35.01.038-.197-17.969 35.042-.032.165 17.963zM121.627 153.055l-35.014.048-.278-17.921 35.052-.048.24 17.921zM160.88 152.996l-34.983.048-.24-17.916 35.02-.042.203 17.91zM200.089 152.937l-34.945.054-.203-17.911 34.983-.043.165 17.9zM122.065 185.215l-34.956.064-.278-17.863 34.994-.053.24 17.852zM161.247 185.139l-34.924.07-.235-17.857 34.957-.059.202 17.846zM200.388 185.07l-34.887.064-.197-17.846 34.919-.059.165 17.841zM122.497 217.268l-34.898.08-.272-17.804 34.93-.069.24 17.793zM161.611 217.177l-34.861.08-.234-17.793 34.892-.069.203 17.782zM200.686 217.086l-34.823.08-.202-17.782 34.86-.069.165 17.771zM122.929 249.208l-34.834.091-.277-17.734 34.871-.091.24 17.734zM161.978 249.102l-34.801.096-.235-17.735 34.833-.085.203 17.724zM200.985 248.995l-34.764.096-.203-17.724 34.801-.085.166 17.713zM123.361 281.038l-34.774.112-.273-17.681 34.807-.102.24 17.671zM162.341 280.92l-34.742.106-.235-17.67 34.775-.101.202 17.665zM201.284 280.797l-34.711.107-.197-17.66 34.743-.101.165 17.654zM123.788 312.761l-34.716.122-.267-17.616 34.748-.113.235 17.607zM162.703 312.628l-34.684.123-.234-17.612 34.716-.112.202 17.601zM201.577 312.489l-34.647.122-.197-17.6 34.679-.112.165 17.59z"></path>
            </g>
            <path
                fill="#91B3FA"
                d="M280.925 79.331c-.037-1.766-1.665-3.191-3.666-3.191H156.065c-2.023 0-4.173 1.468-4.173 3.26v250.431c0 1.34.854 2.62 1.926 3.565 1.073.945 2.647 1.473 4.163 1.473l122.523-.299c1.526 0 3.015-.549 4.082-1.515 1.068-.966 1.665-2.274 1.639-3.624l-5.294-250.105-.006.005z"
            ></path>
            <path
                fill="#BDD0FB"
                d="M211.323 93.885l-39.647-.117.016-4.392 39.604.106.027 4.403zM211.429 110.066l-39.807-.165.016-4.424 39.765.149.026 4.44zM211.542 126.376l-39.973-.203.016-4.461 39.925.186.032 4.478zM211.654 142.818l-40.138-.24.01-4.499 40.096.23.032 4.509zM211.766 159.406l-40.309-.283.016-4.542 40.261.272.032 4.553zM211.99 192.99l-40.645-.368.016-4.617 40.597.358.032 4.627zM212.337 244.437l-41.163-.502.016-4.734 41.115.491.032 4.745zM211.878 176.126l-40.475-.326.016-4.573 40.427.309.032 4.59zM212.102 209.993l-40.816-.411.016-4.654 40.768.401.032 4.664zM212.219 227.14l-40.987-.453.011-4.691 40.944.443.032 4.701zM212.454 261.877l-41.339-.544.016-4.771 41.291.528.032 4.787zM212.572 279.473l-41.515-.592.016-4.814 41.467.577.032 4.829zM212.689 297.218l-41.696-.641.016-4.856 41.648.624.032 4.873zM212.812 315.112l-41.878-.688.016-4.894 41.825.672.037 4.91zM263.304 94.045l-39.898-.122-.043-4.403 39.85.112.091 4.413zM263.624 110.274l-40.058-.16-.043-4.445 40.015.154.086 4.451zM263.949 126.637l-40.223-.202-.043-4.478 40.181.192.085 4.488zM264.28 143.139l-40.394-.246-.043-4.515 40.347.23.09 4.531zM264.611 159.774l-40.56-.283-.048-4.552 40.518.272.09 4.563zM265.283 193.47l-40.906-.368-.043-4.632 40.859.357.09 4.643zM266.314 245.093l-41.43-.502-.048-4.749 41.382.491.096 4.76zM264.948 176.553l-40.736-.326-.043-4.595 40.688.315.091 4.606zM265.625 210.532l-41.077-.411-.048-4.675 41.029.406.096 4.68zM265.966 227.738l-41.253-.459-.048-4.707 41.211.443.09 4.723zM266.66 262.593l-41.606-.544-.048-4.793 41.558.534.096 4.803zM267.013 280.247l-41.788-.592-.048-4.835 41.74.581.096 4.846zM267.37 298.056l-41.968-.646-.048-4.872 41.92.629.096 4.889zM267.728 316.015l-42.151-.694-.048-4.915 42.102.678.097 4.931z"
            ></path>
            <path
                fill="#7D97F4"
                d="M370.712 423.348H70.244c-38.596 0-69.88-31.289-69.88-69.88v-92.482h440.228v92.482c0 38.596-31.284 69.88-69.88 69.88z"
            ></path>
            <path
                fill="url(#paint1_linear_0_407)"
                d="M134.062 176.248c33.492 0 60.642-27.15 60.642-60.642 0-33.492-27.15-60.642-60.642-60.642-33.492 0-60.643 27.15-60.643 60.642 0 33.492 27.151 60.642 60.643 60.642z"
            ></path>
            <path
                fill="#fff"
                d="M157.346 86.771l-6.078-8.662c-.924-1.307-2.429-2.15-4.035-2.15h-27.682c-1.601 0-3.106.843-4.035 2.15l-6.079 8.63a4.963 4.963 0 00-.256 5.316l14.004 24.698c.881 1.543 2.519 2.626 4.291 2.626h11.832c1.772 0 3.41-1.073 4.29-2.615l14.004-24.63a5.048 5.048 0 00-.256-5.358v-.005zM146.555 147.36l-.998.053s-9.804 9.089-9.302 9.419c.251.166.827.646 1.334 1.095.107.09.155.234.123.373a.384.384 0 01-.267.288c-.24.07-.486.102-.726.16-.96.246-1.953.294-2.919.294-.961-.069-1.921-.144-2.802-.454-.459-.101-.859-.331-1.286-.491-.39-.224-.8-.416-1.147-.693l-.523-.401c-.171-.133-.31-.309-.465-.453-.331-.283-.549-.657-.816-.988-.23-.357-.433-.736-.619-1.12-.123-.406-.363-.822-.406-1.191l-.139-.555-.037-.138-.021-.208-.048-.422-.096-.838v-.053l-.011-.027v-.011c-.021-.144.021.182.016.144v-.08l.011-.154.01-.31v-.619l.134-.598c.037-.4.208-.779.341-1.158.091-.389.363-.742.523-1.121.23-.357.465-.72.731-1.067.561-.688 1.169-1.371 1.916-1.975.71-.629 1.516-1.11 2.343-1.649.806-.528 1.777-.864 2.519-1.323l.144-.123c.763-.192 1.34-.864 1.457-1.649l.102-.688.821-4.606a5.45 5.45 0 002.546-4.611 5.392 5.392 0 00-1.131-3.314l.64-3.581h-9.035l.656 2.657a5.446 5.446 0 00-2.028 4.238c0 1.713.844 3.33 2.146 4.323l.032 2.198a1.11 1.11 0 01-.673 1.031 9.251 9.251 0 00-1.072.523c-1.094.624-2.13 1.494-3.112 2.342-.992.822-1.889 1.831-2.711 2.909-.389.56-.752 1.158-1.089 1.766-.277.657-.64 1.26-.816 1.97-.203.693-.406 1.382-.459 2.108l-.117 1.072.037 1.068.027.534.016.266.01.134.022.171v.01l.01.027.011.053.171.827.085.411.043.209.08.266.341 1.062c.214.737.577 1.292.876 1.927.352.598.747 1.179 1.184 1.724.475.517.918 1.056 1.479 1.473.272.213.528.453.811.646l.875.544c.582.363 1.217.608 1.836.87.64.192 1.265.443 1.921.533 1.292.299 2.599.31 3.88.241 1.276-.144 2.53-.379 3.709-.828.294-.112.593-.208.881-.33l.848-.406.422-.203.139-.069.042-.027.091-.059.176-.112.71-.459c.491-.363 1.083-.827 1.521-1.27.438-.459.87-.912 1.222-1.43.758-.993 1.297-2.103 1.719-3.224.437-1.12.72-2.273.912-3.426.192-1.163.278-2.241.235-3.437l-.016-.01z"
            ></path>
            <path
                fill="url(#paint2_linear_0_407)"
                d="M91.089 293.957l-15.477-4.189s-3.66 1.062-3.122 6.505c.54 5.444 15.973 4.451 15.973 4.451l2.626-6.761v-.006z"
            ></path>
            <path
                fill="url(#paint3_linear_0_407)"
                d="M228.651 234.067c29.523 7.381 46.847 27.117 55.386 29.113 8.538 1.995 42.753 3.821 48.335 9.003 5.577 5.182.251 8.864 7.424 15.53 7.936 22.393-16.635 29.096-16.635 29.096l-223.362-1.814s-15.071 1.355-15.408-9.409c-.336-10.764 3.33-16.203 4.12-25.894.79-9.692.812-10.183 2.968-15.21 2.156-5.028 23.129-5.572 27.207-11.165 4.082-5.593 8.939-14.511 26.252-17.547 23.914-4.2 66.587-5.983 83.713-1.698v-.005z"
            ></path>
            <path
                fill="url(#paint4_linear_0_407)"
                d="M83.19 304.946c.385 12.37 21.364 10.182 21.455 10.172 0 0 16.678-12.766-6.266-12.28-6.895-.177-13.886-3.832-13.886-3.832l-1.302 5.934v.006z"
            ></path>
            <path
                fill="url(#paint5_linear_0_407)"
                d="M341.157 293.247s.219 3.154-5.695 6.378c-7.327 3.997-32.773-.395-32.773-.395l-2.903 16.373 23.983 1.222c-.56.155 31.493-1.692 17.388-23.578z"
            ></path>
            <path
                fill="url(#paint6_linear_0_407)"
                d="M122.47 269.52s-.72-5.619 5.182-12.509c5.903-6.89 9.35-11.432 13.887-12.6 4.536-1.169 37.758-5.764 39.94-2.231 2.183 3.533 4.99 25.243 4.99 25.243l-64.004 2.097h.005z"
            ></path>
            <path
                fill="#7D97F4"
                d="M142.141 243.818c3.72-.555 31.978-3.837 39.274-2.904l1.889 7.264-60.866 21.342s-.289-4.622 2.748-9.185c5.107-7.658 13.059-16.026 16.95-16.517h.005z"
                opacity="0.23"
            ></path>
            <path
                fill="url(#paint7_linear_0_407)"
                d="M191.416 242.174c.918 4.195 4.313 24.645 4.313 24.645l71.833-.33s-22.644-20.809-40.053-24.102c-17.408-3.292-36.68-2.428-36.093-.213z"
            ></path>
            <path
                fill="url(#paint8_linear_0_407)"
                d="M225.054 240.845c-14.18-1.969-19.378-1.595-34.241-.293l1.43 5.945s22.121-4.339 42.732-1.831c0 0-5.294-3.18-9.921-3.821z"
            ></path>
            <path
                fill="url(#paint9_linear_0_407)"
                d="M330.718 271.116s-11.64-3.731-14.479 5.47c-2.706 8.774 23.557 11.132 23.557 11.132s-1.937-13.011-9.078-16.602z"
            ></path>
            <path
                fill="#BDD0FB"
                d="M118.494 259.577a.87.87 0 00.197-.027c2.732-.827 5.033-3.703 7.701-7.039 3.891-4.867 8.304-10.385 15.498-11.757 13.801-2.636 34.716-4.456 34.924-4.477a.673.673 0 00.614-.732.662.662 0 00-.731-.613c-.208.016-21.198 1.852-35.063 4.493-7.685 1.468-12.462 7.44-16.304 12.243-2.524 3.159-4.707 5.881-7.034 6.591a.677.677 0 00.192 1.323l.006-.005zM97.104 267.241a.68.68 0 00.608-.374c1.131-2.284 6.153-3.319 11.005-4.323 1.734-.357 3.533-.731 5.182-1.163a.68.68 0 00.485-.827.686.686 0 00-.827-.486c-1.617.422-3.394.79-5.113 1.147-5.411 1.116-10.519 2.173-11.943 5.049a.675.675 0 00.603.977z"
            ></path>
            <path
                fill="url(#paint10_linear_0_407)"
                d="M155.496 315.955c.957-11.842-7.868-22.218-19.71-23.175-11.843-.957-22.219 7.867-23.176 19.71-.957 11.842 7.868 22.218 19.71 23.175 11.843.957 22.219-7.867 23.176-19.71z"
            ></path>
            <path
                fill="url(#paint11_linear_0_407)"
                d="M147.547 314.36c-.197 7.578-6.5 13.561-14.079 13.369-7.578-.198-13.56-6.501-13.368-14.079.197-7.578 6.5-13.561 14.078-13.369 7.579.198 13.561 6.501 13.369 14.079z"
                opacity="0.57"
            ></path>
            <path
                fill="url(#paint12_linear_0_407)"
                d="M308.415 318.237c2.938-11.512-4.012-23.227-15.524-26.165-11.512-2.939-23.226 4.011-26.165 15.523-2.938 11.512 4.012 23.227 15.524 26.165 11.512 2.939 23.226-4.011 26.165-15.523z"
            ></path>
            <path
                fill="url(#paint13_linear_0_407)"
                d="M301.062 313.031c-.198 7.578-6.501 13.56-14.079 13.368-7.578-.197-13.561-6.5-13.369-14.078.198-7.579 6.501-13.561 14.079-13.369 7.578.197 13.561 6.5 13.369 14.079z"
                opacity="0.57"
            ></path>
            <path
                fill="#BDD0FB"
                d="M195.803 313.282h.069c.395 0 .705-.155.699-.545 0-.283-.176-.443-.416-.549-1.398-2.253-3.213-26.53-4.04-41.526a.696.696 0 00-.747-.651.723.723 0 00-.673.757c.006.107.593 10.514 1.431 20.948 1.707 21.24 2.759 21.566 3.677 21.566z"
            ></path>
            <path
                fill="url(#paint14_linear_0_407)"
                d="M258.58 272.188h-14.623a4.697 4.697 0 00-4.697 4.697v.747a4.696 4.696 0 004.697 4.696h14.623a4.696 4.696 0 004.696-4.696v-.747a4.697 4.697 0 00-4.696-4.697z"
            ></path>
            <path
                fill="url(#paint15_linear_0_407)"
                d="M365.279 235.279h5.305a1.7 1.7 0 011.703 1.649l3.047 103.155-13.924-.384 3.869-104.415v-.005z"
            ></path>
            <path
                fill="url(#paint16_linear_0_407)"
                d="M328.156 338.54l20.456-101.154a2.63 2.63 0 012.578-2.103h14.089l3.469 103.439-40.597-.177.005-.005z"
            ></path>
            <path
                fill="url(#paint17_linear_0_407)"
                d="M368.754 354.792H92.669a2.312 2.312 0 01-2.31-2.311v-11.746a2.407 2.407 0 012.406-2.407h275.989v16.469-.005z"
            ></path>
            <path
                fill="url(#paint18_linear_0_407)"
                d="M434.53 291.48l-12.99-47.321c-.326-1.201-1.265-1.409-2.322-1.409h-47.919c-2.588 0-4.686 2.182-4.686 4.872v106.993h70.985l-3.074-63.135h.006z"
            ></path>
            <path
                fill="url(#paint19_linear_0_407)"
                d="M439.189 332.345c-.395-.689-1.041-1.062-1.591-1.036l-27.554 1.398a3.661 3.661 0 00-3.474 3.629l-.15 19.715 31.194 2.001c1.132 0 2.412-1.441 2.412-3.458V334.97c0-.987-.437-1.932-.832-2.62l-.005-.005z"
            ></path>
            <path
                fill="url(#paint20_linear_0_407)"
                d="M424.389 293.61l-7.85-37.95c-.272-1.324-1.249-2.327-2.364-2.327h-30.703c-.662 0-1.292.4-1.751.982-.458.576-.709 1.398-.688 2.204l.736 30.431c.033 1.43.897 2.636 2.05 2.86l37.817 7.466c.811.16 1.633-.187 2.188-.928.555-.742.768-1.767.565-2.743v.005z"
            ></path>
            <path
                fill="url(#paint21_linear_0_407)"
                d="M424.385 252.581l-.459.053c-.78.091-1.484.529-1.948 1.206a3.157 3.157 0 00-.475 2.359l7.594 39.402c.246 1.286 2.999 2.103 4.712 2.209a.842.842 0 00.886-.779l.283-3.378c.027-.336 0-.672-.085-.993l-10.503-40.085-.005.006z"
            ></path>
            <path
                fill="url(#paint22_linear_0_407)"
                d="M395.309 296.977h-9.734a2.215 2.215 0 00-2.215 2.215v.4c0 1.223.991 2.215 2.215 2.215h9.734a2.215 2.215 0 002.215-2.215v-.4a2.215 2.215 0 00-2.215-2.215z"
            ></path>
            <path
                fill="#fff"
                d="M370.482 323.918a.535.535 0 01-.533-.534v-56.981c0-.293.24-.534.533-.534.294 0 .534.241.534.534v56.981c0 .294-.24.534-.534.534z"
                opacity="0.7"
            ></path>
            <path
                fill="url(#paint23_linear_0_407)"
                d="M434.807 337.047h-6.704a2.444 2.444 0 00-2.444 2.444v7.343a2.445 2.445 0 002.444 2.445h6.704a2.445 2.445 0 002.444-2.445v-7.343a2.444 2.444 0 00-2.444-2.444z"
            ></path>
            <path
                fill="#fff"
                d="M430.164 335.883v14.164h-1.74c-1.345 0-3.736-1.435-3.736-2.78v-8.032c0-1.345 2.386-3.352 3.736-3.352h1.74z"
                opacity="0.8"
            ></path>
            <path
                fill="url(#paint24_linear_0_407)"
                d="M366.768 339.822H81.056l-.347-3.176 17.153-3.17 268.906.352v5.994z"
            ></path>
            <path
                fill="url(#paint25_linear_0_407)"
                d="M397.914 380.638c12.945 0 23.439-10.494 23.439-23.439 0-12.946-10.494-23.44-23.439-23.44s-23.439 10.494-23.439 23.44c0 12.945 10.494 23.439 23.439 23.439z"
            ></path>
            <path
                fill="url(#paint26_linear_0_407)"
                d="M402.274 375.74c10.229-2.414 16.565-12.664 14.15-22.893-2.414-10.23-12.664-16.565-22.894-14.151-10.229 2.415-16.564 12.664-14.15 22.894 2.414 10.229 12.664 16.565 22.894 14.15z"
            ></path>
            <path
                fill="#fff"
                d="M413.898 364.297a.57.57 0 01-.208-.043.528.528 0 01-.283-.699 16.256 16.256 0 001.281-6.351c0-8.997-7.322-16.32-16.32-16.32-2.791 0-5.545.716-7.963 2.071a.533.533 0 11-.523-.929 17.38 17.38 0 018.486-2.209c9.585 0 17.387 7.797 17.387 17.387 0 2.349-.459 4.622-1.366 6.767a.534.534 0 01-.491.326z"
                opacity="0.7"
            ></path>
            <path
                fill="url(#paint27_linear_0_407)"
                d="M406.394 359.187a8.73 8.73 0 10-16.995-4.011 8.73 8.73 0 006.492 10.503 8.73 8.73 0 0010.503-6.492z"
            ></path>
            <path
                fill="url(#paint28_linear_0_407)"
                d="M197.763 363.217c2.974-12.599-4.829-25.223-17.428-28.197s-25.223 4.829-28.197 17.428c-2.973 12.599 4.829 25.223 17.428 28.197s25.224-4.829 28.197-17.428z"
            ></path>
            <path
                fill="url(#paint29_linear_0_407)"
                d="M179.314 376.387c10.229-2.414 16.565-12.664 14.15-22.894-2.414-10.229-12.664-16.565-22.893-14.15-10.23 2.414-16.565 12.664-14.151 22.894 2.414 10.229 12.664 16.565 22.894 14.15z"
            ></path>
            <path
                fill="#fff"
                d="M190.94 364.947a.578.578 0 01-.208-.043.53.53 0 01-.283-.699 16.242 16.242 0 001.281-6.351c0-8.998-7.322-16.32-16.32-16.32-2.791 0-5.545.715-7.962 2.071a.532.532 0 11-.523-.929 17.377 17.377 0 018.485-2.209c9.585 0 17.387 7.797 17.387 17.387 0 2.348-.458 4.622-1.366 6.767a.533.533 0 01-.491.326z"
                opacity="0.7"
            ></path>
            <path
                fill="url(#paint30_linear_0_407)"
                d="M183.528 359.499a8.732 8.732 0 10-17.149-3.3 8.732 8.732 0 0017.149 3.3z"
            ></path>
            <path
                fill="url(#paint31_linear_0_407)"
                d="M330.335 360.129c1.274-12.883-8.136-24.359-21.018-25.633-12.883-1.275-24.359 8.135-25.633 21.017-1.275 12.883 8.135 24.359 21.017 25.633 12.883 1.275 24.359-8.135 25.634-21.017z"
            ></path>
            <path
                fill="url(#paint32_linear_0_407)"
                d="M310.62 376.545c10.321-1.987 17.077-11.965 15.09-22.286-1.988-10.321-11.966-17.077-22.287-15.09-10.321 1.988-17.076 11.966-15.089 22.287 1.988 10.321 11.966 17.077 22.286 15.089z"
            ></path>
            <path
                fill="#fff"
                d="M323.016 364.947a.578.578 0 01-.208-.043.53.53 0 01-.283-.699 16.242 16.242 0 001.281-6.351c0-8.997-7.322-16.32-16.32-16.32-2.791 0-5.545.716-7.962 2.071a.532.532 0 11-.523-.929 17.377 17.377 0 018.485-2.209c9.585 0 17.388 7.797 17.388 17.387a17.25 17.25 0 01-1.367 6.767.532.532 0 01-.491.326z"
                opacity="0.7"
            ></path>
            <path
                fill="url(#paint33_linear_0_407)"
                d="M315.602 359.502a8.73 8.73 0 00-6.923-10.224 8.731 8.731 0 106.923 10.224z"
            ></path>
            <path
                fill="url(#paint34_linear_0_407)"
                d="M144.151 363.224c2.974-12.599-4.829-25.223-17.428-28.197-12.599-2.973-25.224 4.83-28.197 17.429-2.974 12.599 4.829 25.223 17.428 28.196 12.599 2.974 25.223-4.829 28.197-17.428z"
            ></path>
            <path
                fill="url(#paint35_linear_0_407)"
                d="M124.935 376.548c10.321-1.988 17.077-11.966 15.09-22.287-1.988-10.321-11.966-17.076-22.287-15.089-10.321 1.988-17.077 11.966-15.089 22.286 1.987 10.321 11.965 17.077 22.286 15.09z"
            ></path>
            <path
                fill="#fff"
                d="M137.328 364.948a.573.573 0 01-.208-.043.53.53 0 01-.283-.699 16.242 16.242 0 001.281-6.351c0-8.998-7.322-16.32-16.32-16.32-2.791 0-5.545.715-7.968 2.071a.534.534 0 01-.523-.929 17.38 17.38 0 018.485-2.209c9.585 0 17.388 7.797 17.388 17.387a17.27 17.27 0 01-1.366 6.767.534.534 0 01-.491.326h.005z"
                opacity="0.7"
            ></path>
            <path
                fill="url(#paint36_linear_0_407)"
                d="M129.916 359.504a8.731 8.731 0 10-17.148-3.302 8.731 8.731 0 0017.148 3.302z"
            ></path>
            <path
                fill="url(#paint37_linear_0_407)"
                d="M6.314 256.781c3.148-5.241 3.96-9.942 3.03-16.026-1.536-10.039-.34-21.214 6.058-29.47 6.068-7.835 16.987-8.534 23.653-15.525.048-.048.197-.278.422-.63a17.38 17.38 0 002.71-8.811c.652-19.671 14.96-19.442 21.748-15.711 10.749 5.907 8.39 16.933 8.39 16.933-3 3.208-13.71-3.629-13.71-3.629l-4.452 7.146a96.68 96.68 0 014.094 1.895c10.087 4.947 11.17 43.591 5.486 49.771s-6.682 12.083-.95 22.196c5.732 10.113 2.418 23.322-28.077 34.278-4.936 1.777-12.376 1.964-17.254-.01C6.762 294.849.875 282.12.587 271.159c-.15-5.567 2.994-9.836 5.721-14.378h.006z"
            ></path>
            <path
                fill="#fff"
                d="M14.217 244.148a.133.133 0 01-.133-.122c-1.254-13.977 3.02-23.183 6.831-28.44 4.787-6.613 10.38-9.484 12.931-10.14 5.625-1.441 8.246-8.059 8.272-8.128a.131.131 0 01.171-.075.13.13 0 01.075.171c-.027.069-2.7 6.815-8.454 8.288-3.26.838-8.656 4.333-12.781 10.039-3.779 5.224-8.027 14.366-6.778 28.263a.132.132 0 01-.123.144h-.01zM19.197 293.226s-.032 0-.048-.01c-.123-.048-12.227-4.899-12.013-18.321 0-.075.058-.134.133-.134.075 0 .133.064.133.134-.208 13.235 11.725 18.022 11.848 18.07a.13.13 0 01.075.171.132.132 0 01-.123.085l-.005.005z"
            ></path>
            <path
                fill="url(#paint38_linear_0_407)"
                d="M93.17 243.951s-13.202 15.813-26.496 2.973l-5.14 11.912s19.416 15.033 34.145-8.619l-2.508-6.266z"
            ></path>
            <path
                fill="url(#paint39_linear_0_407)"
                d="M60.562 214.599c-3.666-1.099-14.334-3.127-24.485 6.239a6.283 6.283 0 00-1.81 6.265c2.728 10.039 9.922 39.69 3.614 52.525 0 0 11.117 12.254 23.242 2.375 0 0 5.438-23.711 12.568-34.124 4.92-7.188-7.845-26.988-11.074-31.77a3.787 3.787 0 00-2.05-1.51h-.005z"
            ></path>
            <path
                fill="url(#paint40_linear_0_407)"
                d="M54.884 195.461s-7.397 14.484-8.694 21.134c0 0 5.577 3.49 11.784-.32 0 0 2.61-15.104 3.816-17.708l-6.906-3.106z"
            ></path>
            <path
                fill="url(#paint41_linear_0_407)"
                d="M75.271 331.79c-.043 1.078 1.847 9.617 2.876 14.17a7.479 7.479 0 01-.805 5.379l-35.624 59.954a8.03 8.03 0 00-.934 2.332c-.65 2.813-2.006 9.708-1.302 15.984l1.841 3.827-7.967-1.81-1.735-21.4 2.258-1.377a10.719 10.719 0 004.333-5.076c3.223-7.823 11.218-27.74 13.283-37.448 2.343-11.031 14.591-19.992 14.591-19.992l-2.15-5.086 11.335-9.457z"
            ></path>
            <path
                fill="url(#paint42_linear_0_407)"
                d="M24.496 424.261s4.302-6.825 4.809-9.478c.506-2.657 1.916-7.349 4.568-5.934 0 0 1.249 12.904.822 17.942-.433 5.043 5.7 4.878 5.7 4.878s1.691.235 2.924 1.473c.854.854.245 2.337-.96 2.412-2.007.128-5.193.166-8.54-.486a2.612 2.612 0 01-2.108-2.412l-.885-14.852-5.428 6.858-.907-.411.005.01z"
            ></path>
            <path
                fill="url(#paint43_linear_0_407)"
                d="M53.993 341.338s-1.254 53.63-1.425 61.245c-.17 7.616 1.2 24.496 8.838 29.54l-3.325 2.46s-4.152-3.528-8.208-10.321c-4.558-7.632-5.935-9.025-5.935-9.025l1.51-3.095a6.777 6.777 0 00.55-4.366c-1.649-7.984-7.15-34.55-8.656-40.266-1.772-6.751-1.9-15.771 4.27-23.317 6.164-7.546 12.376-2.85 12.376-2.85l.005-.005z"
            ></path>
            <path
                fill="url(#paint44_linear_0_407)"
                d="M46.943 437a.468.468 0 01-.47-.4c-.256-1.788-1.313-8.956-2.177-10.813-.993-2.124-4.232-11.074 0-11.832 0 0 10.524 15.37 12.541 17.447 2.018 2.07 4.569.725 4.569.725s1.969.582 3.453 2.477c.704.902.048 2.225-1.1 2.236l-7.087.069a4.984 4.984 0 01-4.675-3.143c-1.249-3.117-3.389-7.685-5.887-9.713l1.297 12.424a.476.476 0 01-.464.523z"
            ></path>
            <path
                fill="url(#paint45_linear_0_407)"
                d="M62.793 276.218s-1.596 5.091.854 13.475l15.22 53.149a1.647 1.647 0 01-1.03 2.002c-4.552 1.633-19.516 6.254-39.946 4.846a2.319 2.319 0 01-2.113-1.804c-1.345-6.058-5.94-26.732-6.884-30.981-3.603-16.186-7.093-31.578 10.604-42.134 8.155 3.496 15.231 3.491 23.295 1.447z"
            ></path>
            <path
                fill="url(#paint46_linear_0_407)"
                d="M44.435 228.096s-3.064 43.783 25.221 21.79c0 0 4.18-3.944 7.194-4.424 1.623-.256 3.459-.432 4.804-.534.613-.048.901.747.395 1.1-.972.683-2.247 1.419-3.352 1.531-2.135.219.139 1.783-2.183 5.871-2.321 4.088-5.64 2.546-5.64 2.546s-32.411 33.189-38.885-24.699c-.23-10.77 10.135-10.199 12.44-3.181h.006z"
            ></path>
            <path
                fill="url(#paint47_linear_0_407)"
                d="M101.854 233.069l-9.623-1.27c-1.147-.192-2.332.481-3.042 1.724l-6.33 13.993c-1.19 2.092-.34 4.862 1.586 5.182l7.728.993c.741.123 1.5-.342 1.915-1.18l8.561-17.088c.496-.987.08-2.215-.795-2.359v.005z"
            ></path>
            <path
                fill="url(#paint48_linear_0_407)"
                d="M95.289 251.941s6.468-9.415 5.721-10.578c-.753-1.158-6.426-2.818-7.754-3.213-1.335-.389-3.838 8.15 2.038 13.785l-.005.006z"
            ></path>
            <path
                fill="url(#paint49_linear_0_407)"
                d="M71.46 187.301s1.377 24.347-8.864 24.688c-10.242.342-11.24-16.971-11.24-16.971s3.026-10.935 7.899-12.21c4.878-1.276 12.2 4.493 12.2 4.493h.005z"
            ></path>
            <path
                fill="url(#paint50_linear_0_407)"
                d="M68.45 179.787s4.68 4.787 3.875 7.765c-.806 2.978-10.845-.139-13.316-1.543l-8.293 8.827s.256-13.075 5.977-17.099c5.721-4.024 11.757 2.055 11.757 2.055v-.005z"
            ></path>
            <path
                fill="url(#paint51_linear_0_407)"
                d="M54.462 195.253s-1.248-8.352-5.331-6.004c-4.083 2.348.299 8.822 3.49 8.416l1.841-2.412z"
            ></path>
            <defs>
                <linearGradient
                    id="paint0_linear_0_407"
                    x1="15.845"
                    x2="35.687"
                    y1="85.821"
                    y2="85.821"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DAE3FE"></stop>
                    <stop offset="1" stopColor="#E9EFFD"></stop>
                </linearGradient>
                <linearGradient
                    id="paint1_linear_0_407"
                    x1="136.052"
                    x2="134.451"
                    y1="47.967"
                    y2="102.403"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint2_linear_0_407"
                    x1="72.581"
                    x2="90.227"
                    y1="293.868"
                    y2="297.944"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2B3582"></stop>
                    <stop offset="1" stopColor="#150E42"></stop>
                </linearGradient>
                <linearGradient
                    id="paint3_linear_0_407"
                    x1="225.054"
                    x2="235.018"
                    y1="234.67"
                    y2="183.437"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint4_linear_0_407"
                    x1="144.559"
                    x2="128.196"
                    y1="229.019"
                    y2="254.993"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint5_linear_0_407"
                    x1="322.264"
                    x2="322.264"
                    y1="211.562"
                    y2="258.173"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint6_linear_0_407"
                    x1="183.126"
                    x2="139.863"
                    y1="190.767"
                    y2="301.57"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint7_linear_0_407"
                    x1="244.896"
                    x2="201.623"
                    y1="214.483"
                    y2="325.313"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint8_linear_0_407"
                    x1="403.696"
                    x2="433.77"
                    y1="-321.968"
                    y2="-410.905"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint9_linear_0_407"
                    x1="362.301"
                    x2="404.601"
                    y1="226.975"
                    y2="159.293"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DAE3FE"></stop>
                    <stop offset="1" stopColor="#E9EFFD"></stop>
                </linearGradient>
                <linearGradient
                    id="paint10_linear_0_407"
                    x1="125.851"
                    x2="183.05"
                    y1="320.784"
                    y2="276.639"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint11_linear_0_407"
                    x1="120.178"
                    x2="147.622"
                    y1="313.57"
                    y2="314.279"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint12_linear_0_407"
                    x1="279.339"
                    x2="336.545"
                    y1="319.245"
                    y2="275.11"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint13_linear_0_407"
                    x1="273.687"
                    x2="301.131"
                    y1="312.245"
                    y2="312.954"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint14_linear_0_407"
                    x1="301.183"
                    x2="283.038"
                    y1="233.219"
                    y2="249.229"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint15_linear_0_407"
                    x1="429.951"
                    x2="346.435"
                    y1="256.701"
                    y2="300.084"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint16_linear_0_407"
                    x1="332.186"
                    x2="335.388"
                    y1="32.543"
                    y2="88.574"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint17_linear_0_407"
                    x1="228.95"
                    x2="231.069"
                    y1="378.156"
                    y2="271.345"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint18_linear_0_407"
                    x1="417.66"
                    x2="338.349"
                    y1="276.729"
                    y2="397.277"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint19_linear_0_407"
                    x1="423.915"
                    x2="420.744"
                    y1="322.989"
                    y2="437.987"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint20_linear_0_407"
                    x1="393.756"
                    x2="453.603"
                    y1="274.712"
                    y2="276.217"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint21_linear_0_407"
                    x1="424.811"
                    x2="447.208"
                    y1="275.14"
                    y2="277.01"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint22_linear_0_407"
                    x1="414.794"
                    x2="376.545"
                    y1="286.821"
                    y2="306.562"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint23_linear_0_407"
                    x1="423.53"
                    x2="430.932"
                    y1="362.108"
                    y2="344.417"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint24_linear_0_407"
                    x1="206.85"
                    x2="210.052"
                    y1="39.7"
                    y2="95.736"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint25_linear_0_407"
                    x1="374.475"
                    x2="421.348"
                    y1="357.199"
                    y2="357.199"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint26_linear_0_407"
                    x1="393.247"
                    x2="401.177"
                    y1="303.061"
                    y2="395.057"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint27_linear_0_407"
                    x1="406.486"
                    x2="382.663"
                    y1="343.237"
                    y2="382.27"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint28_linear_0_407"
                    x1="151.496"
                    x2="198.369"
                    y1="357.972"
                    y2="357.972"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint29_linear_0_407"
                    x1="171.878"
                    x2="179.809"
                    y1="322.136"
                    y2="414.137"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint30_linear_0_407"
                    x1="183.552"
                    x2="159.723"
                    y1="343.79"
                    y2="382.824"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint31_linear_0_407"
                    x1="283.541"
                    x2="330.415"
                    y1="358.102"
                    y2="358.102"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint32_linear_0_407"
                    x1="302.974"
                    x2="310.904"
                    y1="310.834"
                    y2="402.83"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint33_linear_0_407"
                    x1="315.623"
                    x2="291.799"
                    y1="343.795"
                    y2="382.828"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint34_linear_0_407"
                    x1="97.883"
                    x2="144.757"
                    y1="357.972"
                    y2="357.972"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint35_linear_0_407"
                    x1="118.66"
                    x2="126.59"
                    y1="326.728"
                    y2="418.729"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint36_linear_0_407"
                    x1="129.942"
                    x2="106.113"
                    y1="343.793"
                    y2="382.826"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint37_linear_0_407"
                    x1="82.427"
                    x2="61.833"
                    y1="137.114"
                    y2="188.401"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint38_linear_0_407"
                    x1="85.939"
                    x2="74.188"
                    y1="227.396"
                    y2="270.875"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint39_linear_0_407"
                    x1="158.76"
                    x2="137.151"
                    y1="112.628"
                    y2="139.846"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint40_linear_0_407"
                    x1="59.25"
                    x2="53.219"
                    y1="226.304"
                    y2="206.157"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint41_linear_0_407"
                    x1="116.413"
                    x2="93.464"
                    y1="459.687"
                    y2="430.868"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint42_linear_0_407"
                    x1="24.346"
                    x2="43.472"
                    y1="422.38"
                    y2="422.2"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint43_linear_0_407"
                    x1="44.381"
                    x2="100.653"
                    y1="368.657"
                    y2="487.001"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint44_linear_0_407"
                    x1="42.112"
                    x2="64.915"
                    y1="425.665"
                    y2="425.45"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint45_linear_0_407"
                    x1="87.3"
                    x2="39.962"
                    y1="267.732"
                    y2="333.823"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint46_linear_0_407"
                    x1="63.354"
                    x2="113.669"
                    y1="244.213"
                    y2="244.213"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint47_linear_0_407"
                    x1="88.742"
                    x2="97.867"
                    y1="234.501"
                    y2="244.983"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint48_linear_0_407"
                    x1="98.923"
                    x2="92.727"
                    y1="231.997"
                    y2="254.908"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint49_linear_0_407"
                    x1="70.258"
                    x2="35.166"
                    y1="191.642"
                    y2="214.341"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint50_linear_0_407"
                    x1="82.214"
                    x2="61.566"
                    y1="136.558"
                    y2="187.973"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint51_linear_0_407"
                    x1="65.326"
                    x2="30.234"
                    y1="184.015"
                    y2="206.714"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
            </defs>
        </svg>
    );
}

export default MainImg;
